export default __webpack_public_path__ + "static/media/loading.c0569674.gif";